(function () {
  if (window.__hmFfCarouselInit) return;
  window.__hmFfCarouselInit = true;

  function dotsFor(track) {
    var section = track.closest('.hm-ff-media');
    var indicator = section && section.querySelector('[data-ff-carousel-indicator]');
    return indicator ? indicator.children : null;
  }

  function mark(track, index) {
    var dots = dotsFor(track);
    if (!dots) return;
    for (var i = 0; i < dots.length; i++) {
      if (i === index) dots[i].setAttribute('data-active', '');
      else dots[i].removeAttribute('data-active');
    }
  }

  function attach(track) {
    if (track.__hmFfBound) return;
    track.__hmFfBound = true;

    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;

    mark(track, 0);

    function activeByPosition() {
      var rect = track.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        if (r.left <= mid && r.right > mid) return i;
      }
      return -1;
    }

    var queued = false;
    track.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          var i = activeByPosition();
          if (i > -1) mark(track, i);
        });
      },
      { passive: true }
    );

    if ('IntersectionObserver' in window) {
      var ratios = [];
      for (var n = 0; n < slides.length; n++) ratios.push(0);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var i = slides.indexOf(entry.target);
            if (i > -1) ratios[i] = entry.intersectionRatio;
          });

          var best = 0;
          for (var i = 1; i < ratios.length; i++) {
            if (ratios[i] > ratios[best]) best = i;
          }
          if (ratios[best] > 0) mark(track, best);
        },
        { root: track, threshold: [0, 0.25, 0.5, 0.75, 1] }
      );

      slides.forEach(function (slide) {
        observer.observe(slide);
      });
      return;
    }

  }

  function init() {
    document.querySelectorAll('[data-ff-carousel]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
